<template>
  <div>
    <div class="success" v-if="isvisib">
      <div class="cancel" @click="cancel">x</div>
      <ul v-if="onceNum == 2">
        <li class="goldTxt">成功开通黄金会员!</li>
        <li class="goldTxt_1">--尊享黄金会员权益--</li>
      </ul>
      <ul v-else-if="onceNum == 1">
        <li class="goldTxt">成功开通白银会员!</li>
        <li class="goldTxt_1">--尊享白银会员权益--</li>
      </ul>
      <ul v-else-if="onceNum == 3">
        <li class="goldTxt">成功开通钻石会员!</li>
        <li class="goldTxt_1">--尊享钻石会员权益--</li>
      </ul>
      <ul v-else-if="onceNum == 4">
        <li class="goldTxt">成功充值积分!</li>
      </ul>
      <div class="btn" @click="btnClick">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isvisib', 'onceNum'],
  methods: {
    cancel () {
      this.$emit('isBuySuccess', false)
      this.$router.push({ path: '/user/account' })
    },
    btnClick () {
      this.$emit('isBuySuccess', false)
      if (this.$route.path === '/user/account') {
        this.$router.go(0)
      }
      this.$router.push({ path: '/user/account' })
    }
  },
}
</script>

<style lang="less" scoped>
.success {
  background-image: url('../../assets/member/successRecharts.png');
  background-repeat: no-repeat;
  position: relative;
  width: 370px;
  height: 370px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 10000;
  cursor: pointer;

  .cancel {
    width: 30px;
    height: 30px;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 22px;
    text-align: center;
    line-height: 25px;
    border-radius: 50%;
    position: absolute;
    top: -15px;
    right: 25px;
    z-index: 10001;
  }

  ul {
    width: 160px;
    height: 60px;
    position: absolute;
    text-align: center;
    top: 210px;
    left: 80px;

    .goldTxt {
      font-size: 18px;
      font-weight: 600;
    }

    .goldTxt_1 {
      font-size: 16px;
      color: #999;
      margin-top: 10px;
    }

  }

  .btn {
    user-select: none;
    width: 200px;
    height: 40px;
    background-color: #EB5556;
    color: #fff;
    font-size: 22px;
    border-radius: 40px;
    text-align: center;
    line-height: 40px;
    font-weight: bold;
    position: absolute;
    bottom: 60px;
    left: 60px;
  }

}
</style>